import React from 'react'
import './Guided.css'
import pharmacy from '../../../../assets/images/about/pharmacy.png'
import telescope from '../../../../assets/images/about/telescope.png'
import goal from '../../../../assets/images/about/goal.png'
import main from '../../../../assets/images/about/main.webp'

const Guided = () => {
  return (
    <section className="guided">

      <div className="guided-container">

        {/* TOP BANNER */}
        <div className="guided-banner">

          {/* floating badge */}
          <img src={pharmacy} alt="" className="guided-badge" />

          <div className="banner-left">
            <h2>
              Guided by Insight.<br />
              Driven by Expertise.
            </h2>
          </div>

          <div className="banner-right">
            <p>
              API’s transformation is led by a distinguished group of Iraqi market experts with decades of experience in the public and private healthcare sectors. Their local expertise is strengthened by strategic partnerships with global pharmaceutical leaders.
            </p>

            <p>
              Together, we ensure every product manufactured by API meets the highest international standards of safety, efficacy, and quality.
            </p>
          </div>

        </div>

        <div className="guided-row vision">

          <div className="icong">
            <img src={telescope} alt="" />
          </div>

          <div className="content">
            <h3>Vision</h3>
            <p>
              To become a leading pharmaceutical and biotechnology manufacturer in Iraq and the region, and a cornerstone of the Iraqi pharmaceutical industry. API aims to transform market data into life-saving healthcare solutions while becoming the trusted partner for both public and private healthcare providers.
            </p>
          </div>

        </div>

        <div className="guided-divider"></div>

        <div className="guided-row mission">

          <div className="content right">
            <h3>Mission</h3>
            <p>
              To manufacture high-quality pharmaceutical and biological products using advanced production technologies, strict quality standards, and strategic partnerships with international technology providers.
            </p>
          </div>

          <div className="icong">
            <img src={goal} alt="" />
          </div>

        </div>

        <div className="guided-image">
          <img src={main} alt="" />
        </div>

      </div>

    </section>
  )
}

export default Guided